'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import UIButton from 'UIComponents/button/UIButton';
import H3 from 'UIComponents/elements/headings/H3';
import PracticalExerciseCondensedWrapper from './PracticalExerciseCondensedWrapper';
import PracticalExerciseProgressFeedback from './PracticalExerciseProgressFeedback';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CompletedPracticalExerciseCondensed = ({
  advanceToNextContent
}) => {
  return /*#__PURE__*/_jsx(PracticalExerciseCondensedWrapper, {
    buttons: /*#__PURE__*/_jsx(UIButton, {
      onClick: advanceToNextContent,
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.practicalExercise.continue`
      })
    }),
    children: /*#__PURE__*/_jsxs(PracticalExerciseProgressFeedback, {
      illustrationName: "success",
      children: [/*#__PURE__*/_jsx(H3, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.practicalExercise.statusTitle.completed"
        })
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.practicalExercise.statusSubtitle.completed"
      })]
    })
  });
};
CompletedPracticalExerciseCondensed.propTypes = {
  advanceToNextContent: PropTypes.func.isRequired
};
export default CompletedPracticalExerciseCondensed;